<template>
  <div class="z-loading"></div>
</template>

<script>
export default {
  name: 'z-loading'
};
</script>



// WEBPACK FOOTER //
// loading.vue?4abc0443